<template>
  <div>
    <input
      type="text"
      @input="handleChange"
      class="block w-full px-4 py-2 rounded-md text-sm border border-gray-300 focus:ring-indigo-500 focus:border-indigo-500"
      :placeholder="placeholder"
      @click.stop.prevent
    />
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    placeholder: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      debounce: null
    };
  },
  methods: {
    handleChange({ target: { value } }) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.$emit("handleInput", value);
      }, 400);
    }
  }
};
</script>
